import React, { useEffect, useState } from 'react'
import { AppDispatch, RootState } from '@redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { Menu, Dropdown, Button } from 'antd';
import { Link, useLocation } from 'react-router-dom'
import routerConstants from '@constants/routerConstants'
import { userMenu } from '@constants/menuConstants'
import {
  getProjectInfo,
  getBranchInfo,
  getUserInfo, logOut,
  saveAccessToken,
  saveUserInfo,
  saveBranchInfo,
  saveProjectInfo
} from '@utils/userUtils'
import { SyncOutlined, UserOutlined, AppleOutlined, AndroidOutlined, MobileOutlined } from '@ant-design/icons'
import { getListMyChiNhanh, getListMyDuAn } from '@redux/ducks/userDucks'
import { getListHeThong } from '@redux/ducks/heThongDucks';
import ThemeSwitcher from '@theme/ThemeSwitcher';
import * as userApi from '@api/userApi'
import { showMessage } from '@utils/commonUtils';
import { CHUC_NANG_PERMISSION_CODES } from '@constants/permissionConstants';
import { useMenuChucNang } from '@hooks/useMenuChucNang';
import ChiNhanhBranchLabel from '@components/common/selectCommon/ChiNhanhBranchLabel';
import ChiNhanhBranchPickerOverlay from '@components/common/selectCommon/ChiNhanhBranchPickerOverlay';

interface Props { }

const HeaderMenu: React.FC<Props> = () => {
  const dispatch: AppDispatch = useDispatch()
  const { hasChucNangByCode } = useMenuChucNang()
  const { pathname } = useLocation()
  const userInfo = getUserInfo()
  const projectInfo = getProjectInfo()
  const branchInfo = getBranchInfo()
  const myDuAnList = useSelector((state: RootState) => state.user.myDuAnList)
  const [duAns, setDuAns] = useState<any[]>([])

  useEffect(() => {
    getCommonData()
  }, [])

  const getCommonData = () => {
    dispatch(getListHeThong({}))
    dispatch(getListMyDuAn({}))
    dispatch(getListMyChiNhanh({}))
  }

  useEffect(() => {
    let duAns: any[] = []

    if (Array.isArray(myDuAnList?.data) && myDuAnList?.data?.length > 0) {
      myDuAnList?.data?.map((item: any) => {
        if (Array.isArray(item.userNhomQuyens) && item.userNhomQuyens?.length > 0) {
          item.userNhomQuyens?.map((userNhomQuyen: any) => {
            duAns.push({ ...userNhomQuyen.chiNhanh, key: userNhomQuyen.chiNhanh.id, duAn: item })
          })
        } else {
          if (Array.isArray(item.chiNhanhs) && item.chiNhanhs?.length > 0) {
            item.chiNhanhs?.map((chiNhanh: any) => {
              duAns.push({ ...chiNhanh, key: chiNhanh.id, duAn: item })
            })
          }
        }
      })
      setDuAns(duAns)
    }
    setDuAns(duAns)
  }, [JSON.stringify(myDuAnList)])

  const changeBranch = async (item: any) => {
    const res = await userApi.changeBranch(item.duAnId, item.id)
    console.log("res", res)
    saveAccessToken(res.data.access_token)
    saveBranchInfo(JSON.stringify(res.data.chiNhanh))
    saveProjectInfo(JSON.stringify(res.data.duAn))
    const resUser = await userApi.getUserInfo()
    saveUserInfo(JSON.stringify(resUser.data))
    window.location.reload()
  }


  const handleSyncUser = async () => {
    try {
      await userApi.syncUser()
      showMessage('success', 'Đồng bộ user thành công')
    } catch (error) {
      showMessage('error', 'Đồng bộ user thất bại')
    }
  }

  const isHaveChucNangSyncUser = hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_SYNC_USER)

  return (
    <header className="ant-layout-header">
      <div className="navbar-custom">
        {/* Left side menus */}
        <div className="navbar-left">
          <div className="theme-switcher-container theme-switcher-container--chi-nhanh">
            <Dropdown
              trigger={['click']}
              placement="bottomRight"
              overlayClassName="chi-nhanh-picker-dropdown"
              overlay={
                    <ChiNhanhBranchPickerOverlay
                      branches={duAns}
                      activeBranchId={branchInfo?.id}
                      onSelect={(item) => changeBranch(item)}
                    />
                  }
                >
                  <div className="theme-switcher-button">
                    <div className="theme-switcher-content">
                      <UserOutlined style={{ fontSize: '16px', flexShrink: 0 }} />
                      <ChiNhanhBranchLabel
                        line1={projectInfo?.ma || projectInfo?.ten}
                        line2={branchInfo?.ten || branchInfo?.ma}
                      />
                    </div>
                  </div>
            </Dropdown>
          </div>

          {userMenu().map((menuItem) => {
            if (menuItem.children && menuItem.children.length > 0) {
              const isActive = menuItem.children.some(subMenu => pathname.includes(subMenu.startPoint));
              return (
                <div className={`theme-switcher-container ${isActive ? 'active' : ''}`} key={menuItem.key}>
                  <Dropdown
                    placement="bottomLeft"
                    overlay={
                      <Menu className="theme-dropdown-menu">
                        {menuItem.children.map((subMenu, index2) => (
                          <Menu.Item
                            key={menuItem.key + "-" + index2}
                            className={`theme-menu-item ${pathname.includes(subMenu.startPoint) ? 'active' : ''}`}
                          >
                            <Link to={subMenu.path}>
                              <div className="theme-switcher-content">
                                {subMenu.icon && React.createElement(subMenu.icon, { style: { fontSize: '16px' } })}
                                <span>{subMenu.label}</span>
                              </div>
                            </Link>
                          </Menu.Item>
                        ))}
                      </Menu>
                    }
                  >
                    <div className={`theme-switcher-button ${isActive ? 'active' : ''}`}>
                      <div className="theme-switcher-content">
                        {menuItem.icon && React.createElement(menuItem.icon, { style: { fontSize: '16px' } })}
                        <span>{menuItem.label}</span>
                      </div>
                    </div>
                  </Dropdown>
                </div>
              );
            }
            return (
              <div
                className={`theme-switcher-container ${pathname.includes(menuItem.startPoint) ? 'active' : ''}`}
                key={menuItem.key}
                data-menu={menuItem.key}
              >
                <Link to={menuItem.path}>
                  <div className={`theme-switcher-button ${pathname.includes(menuItem.startPoint) ? 'active' : ''}`}>
                    <div className="theme-switcher-content">
                      {menuItem.icon && React.createElement(menuItem.icon, { style: { fontSize: '16px' } })}
                      <span>{menuItem.label}</span>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>


        {/* Right side menus */}
        <div className="navbar-right">
          <div className="theme-switcher-container">
            <Dropdown
              trigger={['click']}
              placement="bottomRight"
              overlay={
                <Menu className="theme-dropdown-menu">
                  <Menu.Item key="app-ios" className="theme-menu-item">
                    <a
                      href="https://apps.apple.com/us/app/kho-l%C3%AA-tr%E1%BA%A7n/id6746059340"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="theme-switcher-content">
                        <AppleOutlined style={{ fontSize: '16px' }} />
                        <span>iOS</span>
                      </div>
                    </a>
                  </Menu.Item>
                  <Menu.Item key="app-android" className="theme-menu-item">
                    <a
                      href="https://play.google.com/apps/testing/vn.letrangroup.kholetran"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="theme-switcher-content">
                        <AndroidOutlined style={{ fontSize: '16px' }} />
                        <span>Android</span>
                      </div>
                    </a>
                  </Menu.Item>
                </Menu>
              }
            >
              <div className="theme-switcher-button">
                <div className="theme-switcher-content">
                  <MobileOutlined style={{ fontSize: '16px' }} />
                  <span>Tải app</span>
                </div>
              </div>
            </Dropdown>
          </div>
          {
            isHaveChucNangSyncUser && (
              <div className="theme-switcher-container">
                <div className="theme-switcher-button">
                  <div className="theme-switcher-content">
                    <Button
                      icon={<SyncOutlined />}
                      onClick={handleSyncUser}
                      type="text" size="small"
                      className="hover:text-blue-500">
                      <span>User</span>
                    </Button>
                  </div>
                </div>
              </div>
            )
          }

          <div className="theme-switcher-container">
            <Dropdown
              trigger={['click']}
              placement="bottomRight"
              overlay={
                <Menu className="theme-dropdown-menu">
                  <Menu.Item
                    key="logout"
                    className="theme-menu-item"
                    onClick={() => logOut()}
                  >
                    Đăng xuất
                  </Menu.Item>
                  <Menu.Item key="changePwd" className="theme-menu-item">
                    <Link to={routerConstants.user.changePWD}>Đổi mật khẩu</Link>
                  </Menu.Item>
                </Menu>
              }
            >
              <div className="theme-switcher-button">
                <div className="theme-switcher-content">
                  <UserOutlined style={{ fontSize: '16px' }} />
                  <span>{userInfo?.username}</span>
                </div>
              </div>
            </Dropdown>
          </div>

          <ThemeSwitcher />
        </div>
      </div>
    </header>
  )
}

export default HeaderMenu
